exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".win-x {\n    position: relative;\n    float: right;\n    cursor: pointer;\n}\n\n.win-x.disabled {\n    cursor: default;\n}\n\n.qwin-head {\n    padding: 6px 6px 6px 18px;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.win-x i.fa:before {\n    content: \"\\F2D3\";\n    font-size: 1.4em;\n}\n.win-x:not(.disabled) i.fa:active:before {\n    content: \"\\F2D4\";\n}\n\n.win-x:not(.disabled):hover {\n    right: 1px;\n    top: 1px;\n}\n\n.win-x.disabled {\n    opacity: 0.3;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/modal-win-new-lead/win.css
// module id = 1227
// module chunks = 9